import { createApp } from 'vue'
import FrontendMockupTool from './FrontendMockupTool.vue'
import store from './store'
import Clipboard from 'v-clipboard'
import vClickOutside from 'click-outside-vue3'

createApp(FrontendMockupTool)
  .use(store)
  .use(Clipboard)
  .use(vClickOutside)
  .mount('#js-create_frontend_mockup_tool_app')